export default "__VITE_ASSET__DTMkO0kS__"